export default {
  namespaced: true,
  state: {
    addToHomeScreen: null,
  },
  mutations: {
    setAddToHomeScreen(state, val) {
      state.addToHomeScreen = val;
    },
  },
  actions: {
    addToHomeScreen({state, commit}) {
      if (state.addToHomeScreen) {
        state.addToHomeScreen.prompt();
        state.addToHomeScreen.userChoice.then(function (choiceResult) {
          if (choiceResult.outcome === "dismissed") {
            commit("snackbar/setSnackbar", {
              color: "primary",
              timeout: 5000,
              text: "You can still install it from the options of your browser",
            },{ root: true });
          } else {
            commit("snackbar/setSnackbar", {
              color: "primary",
              timeout: 4000,
              text: "Green Neightbours is being added to your homescreen",
            },{ root: true });
          }
        });
        commit("setAddToHomeScreen", null);
      }
    }
  }
}
  